import React from 'react';
import { MessageInput } from '@auw/workspace-ui';
import type { WorkspaceMode } from '@auw/workspace-utils';

interface WorkspaceComposerProps {
  modeOverride?: WorkspaceMode;
  placeholderOverride?: string;
  beforeSubmit?: React.ComponentProps<typeof MessageInput>['beforeSubmit'];
  onSubmitOverride?: React.ComponentProps<typeof MessageInput>['onSubmitOverride'];
}

export const WorkspaceComposer: React.FC<WorkspaceComposerProps> = (props) => {
  return <MessageInput {...props} />;
};
